"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VantageScoreCard = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const score_breakdown_1 = __importDefault(require("../../components/score-breakdown"));
const StyledStandardCard = (0, styled_components_1.default)(base_react_components_1.StandardCard).withConfig({ displayName: "reports-StyledStandardCard", componentId: "reports-ljy9qs" }) `
  display: grid;
  grid-gap: 16px;
`;
const MeaningColorIndicator = styled_components_1.default.div.withConfig({ displayName: "reports-MeaningColorIndicator", componentId: "reports-17okc80" }) `
  min-width: 6px;
  width: 6px;
  border-radius: 8px;
  background-color: ${({ bgColor }) => bgColor};
`;
const MeaningContent = styled_components_1.default.div.withConfig({ displayName: "reports-MeaningContent", componentId: "reports-uy206m" }) `
  display: flex;
  flex-direction: column;
`;
const MeaningDefinition = styled_components_1.default.li.withConfig({ displayName: "reports-MeaningDefinition", componentId: "reports-ab1yjz" }) `
  display: grid;
  grid-template-columns: 6px 1fr;
  grid-gap: 8px;
`;
const ScoreMeaning = styled_components_1.default.ul.withConfig({ displayName: "reports-ScoreMeaning", componentId: "reports-m9y2sx" }) `
  padding: 0;
  display: grid;
  grid-gap: 16px;
`;
const ScoreHeader = styled_components_1.default.div.withConfig({ displayName: "reports-ScoreHeader", componentId: "reports-1lruiv4" }) `
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-gap: 16px;
`;
/**
 * The IntelliscoreCard component displays static educational content for Experian Intelliscore Plus℠ V2 score.
 *
 * @returns ReactElement
 */
const VantageScoreCard = () => {
    const segmentBreakdown = [
        { label: '40%', color: base_react_components_1.theme.colorRainbow[0] },
        { label: '21%', color: base_react_components_1.theme.colorRainbow[1] },
        { label: '20%', color: base_react_components_1.theme.colorRainbow[2] },
        { label: '11%', color: base_react_components_1.theme.colorRainbow[3] },
        { label: '5%', color: base_react_components_1.theme.colorRainbow[4] },
        { label: '3%', color: base_react_components_1.theme.colorRainbow[5] },
    ];
    const legendBreakdown = [
        'Payment history: extremely influential',
        'Age and type of credit: highly influential',
        'Percentage of credit limit used: highly influential',
        'Total balances and debt: moderately influential',
        'Recent credit behavior and inquiries: less influential',
        'Available credit: less influential',
    ];
    return (react_1.default.createElement(StyledStandardCard, { "data-testid": "score-explanation" },
        react_1.default.createElement(ScoreHeader, null,
            react_1.default.createElement(base_react_components_1.Icon, { name: "actions/circle-info" }),
            react_1.default.createElement(base_react_components_1.Header, { size: "lg" }, "How is VantageScore\u00AE 3.0 calculated?")),
        react_1.default.createElement(base_react_components_1.Copy, null, "VantageScore 3.0 credit scores range from 300 to 850. Earlier iterations of the VantageScore\u00AE model featured a different range, but VantageScore 3.0 adopted the 300 to 850 range \u2014 the same range as most FICO\u00AE scores \u2014 to make it easier for lenders to use."),
        react_1.default.createElement(base_react_components_1.Copy, null, "Though individual credit scores are based on a complex series of calculations, VantageScore does offer some insight into how the various credit factors are used to calculate a VantageScore 3.0 score."),
        react_1.default.createElement(base_react_components_1.Copy, null, "Generally, here\u2019s how the categories can break down."),
        react_1.default.createElement(score_breakdown_1.default, { segmentBreakdown: segmentBreakdown, legendBreakdown: legendBreakdown }),
        react_1.default.createElement(base_react_components_1.Header, { size: "lg" }, "What does my score mean?"),
        react_1.default.createElement(ScoreMeaning, null,
            react_1.default.createElement(MeaningDefinition, null,
                react_1.default.createElement(MeaningColorIndicator, { bgColor: base_react_components_1.theme.statusColors.good.color }),
                react_1.default.createElement(MeaningContent, null,
                    react_1.default.createElement(base_react_components_1.Copy, null,
                        react_1.default.createElement("strong", null, "781-850")),
                    react_1.default.createElement(base_react_components_1.Copy, null, "Super Prime"))),
            react_1.default.createElement(MeaningDefinition, null,
                react_1.default.createElement(MeaningColorIndicator, { bgColor: base_react_components_1.theme.statusColors.semigood.color }),
                react_1.default.createElement(MeaningContent, null,
                    react_1.default.createElement(base_react_components_1.Copy, null,
                        react_1.default.createElement("strong", null, "661-780")),
                    react_1.default.createElement(base_react_components_1.Copy, null, "Prime"))),
            react_1.default.createElement(MeaningDefinition, null,
                react_1.default.createElement(MeaningColorIndicator, { bgColor: base_react_components_1.theme.statusColors.fair.color }),
                react_1.default.createElement(MeaningContent, null,
                    react_1.default.createElement(base_react_components_1.Copy, null,
                        react_1.default.createElement("strong", null, "601-660")),
                    react_1.default.createElement(base_react_components_1.Copy, null, "Near Prime"))),
            react_1.default.createElement(MeaningDefinition, null,
                react_1.default.createElement(MeaningColorIndicator, { bgColor: base_react_components_1.theme.statusColors.semipoor.color }),
                react_1.default.createElement(MeaningContent, null,
                    react_1.default.createElement(base_react_components_1.Copy, null,
                        react_1.default.createElement("strong", null, "500-600")),
                    react_1.default.createElement(base_react_components_1.Copy, null, "Subprime"))),
            react_1.default.createElement(MeaningDefinition, null,
                react_1.default.createElement(MeaningColorIndicator, { bgColor: base_react_components_1.theme.statusColors.poor.color }),
                react_1.default.createElement(MeaningContent, null,
                    react_1.default.createElement(base_react_components_1.Copy, null,
                        react_1.default.createElement("strong", null, "300-499")),
                    react_1.default.createElement(base_react_components_1.Copy, null, "Deep Subprime"))))));
};
exports.VantageScoreCard = VantageScoreCard;
exports.default = (0, styled_components_1.default)(exports.VantageScoreCard).withConfig({ componentId: "reports-aj1por" }) ``;
//# sourceMappingURL=index.js.map